import { publicApi } from './api'
import api from './api'

export async function getQrInfoPublico(inscricaoId) {
  const { data } = await publicApi.get(`/pub/inscricao/${inscricaoId}/qr`)
  return data.inscricao
}

export async function scanInscricao(inscricaoId, { dryRun = false, observacao = null } = {}) {
  const { data } = await api.post(`/scan/${inscricaoId}`, { dryRun, observacao })
  return data
}

export async function uncheckInscricao(inscricaoId) {
  const { data } = await api.post(`/checkin/${inscricaoId}/uncheck`)
  return data
}

export async function getCheckinLista(params = {}) {
  const { data } = await api.get('/checkin/lista', { params })
  return data.inscricoes
}

export async function getCheckinStats(params = {}) {
  const { data } = await api.get('/checkin/stats', { params })
  return data
}
